import { PrimaryButton } from "@fluentui/react";
import { DropDownPicker, stringUtils, TextField } from "cayo.ui";
import React, { FC, useCallback, useEffect, useRef } from "react";
import { useIntl } from "react-intl";
import styled from "styled-components";
import { ITextField } from "../../api/schema.api";
import logger from "@cayo/shared/libs/logger";
import { IFormComponent } from "../QueryFilterForm/IFormComponent";
import { commonMessages } from "@cayo/shared/messages/common";

type InplaceTextFieldProps = ITextField &
  IFormComponent & {
    defaultValue?: string | undefined;
    onApply?: () => void;
    onPickerStateChanged?: (isOpened: boolean) => void;
  };

const log = logger.getLogger("InplaceTextField");

const InplaceTextField: FC<InplaceTextFieldProps> = (props) => {
  const intl = useIntl();
  const toggleDropDownPicker = useRef<() => void>();
  const { onApply, onPickerStateChanged } = props;

  const pickerOpened = useRef(false);
  const pickerStateHandler = useCallback(
    function (isOpened: boolean) {
      if (props.onPickerStateChanged) {
        pickerOpened.current = isOpened;
        props.onPickerStateChanged(isOpened);
      }
    },
    [props.onPickerStateChanged]
  );

  useEffect(() => {
    return () => {
      if (pickerOpened.current) {
        onPickerStateChanged && onPickerStateChanged(false);
      }

      log.debug("unmount", props.name);
    };
  }, []);
  return (
    <DropDownPicker
      title={props.shortName}
      initToggle={(f) => {
        toggleDropDownPicker.current = f;
      }}
      onPickerStateChanged={pickerStateHandler}
      isActive={!!props.defaultValue}
    >
      <Text {...props} />

      {onApply && (
        <ButtonWrapper>
          <PrimaryButton
            text={intl.formatMessage(commonMessages.apply)}
            onClick={() => {
              onApply();
              toggleDropDownPicker.current && toggleDropDownPicker.current();
            }}
            styles={{ root: { marginTop: 6, width: "100%" } }}
          />
        </ButtonWrapper>
      )}
    </DropDownPicker>
  );
};

const Text = (props: InplaceTextFieldProps) => {
  return (
    <TextField
      key={props.name}
      type={"text"}
      autoFocus={props.autoFocus}
      defaultValue={props.defaultValue}
      tooltip={props?.tooltip}
      setValue={(e, value) => {
        if (e.key === "Escape") {
          props.setValue(props.defaultValue, props);
        } else if (e.key === "Enter") {
          props.setValue(value, props);
        }
      }}
      onBlur={(e) => {
        logger.debug(e);

        // if ((props.value || "") !== (e.currentTarget.value || "")) {
        props.setValue(e.currentTarget.value, props);
        // }
      }}
      label={props.label || stringUtils.toSpaceDelimitedPascalCase(props.name!)}
      styles={{ field: { minWidth: 300, maxWidth: 700, width: "100%" } }}
    />
  );
};

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export default InplaceTextField;
